import { render } from "./AccountSettingsPage.vue?vue&type=template&id=360f7feb&scoped=true"
import script from "./AccountSettingsPage.vue?vue&type=script&lang=ts"
export * from "./AccountSettingsPage.vue?vue&type=script&lang=ts"

import "./AccountSettingsPage.vue?vue&type=style&index=0&id=360f7feb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-360f7feb"

export default script